import { render, staticRenderFns } from "./Foil.vue?vue&type=template&id=21b8bf22&scoped=true"
import script from "./Foil.vue?vue&type=script&lang=js"
export * from "./Foil.vue?vue&type=script&lang=js"
import style0 from "./Foil.vue?vue&type=style&index=0&id=21b8bf22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8bf22",
  null
  
)

export default component.exports